<template>
  <v-container>
    <div class="text-center">
      <h2 class="mb-5">ຜູ້ໂຊກດີຖືກລາງວັນ</h2>
    </div>
    <v-row>
      <v-col
        v-for="(item, index) in displayedImages"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        :style="{ marginTop: index === 0 || index === 2 ? '30px' : '0' }"
      >
        <v-card style="padding: 10px">
          <v-img
            :src="item.image"
            alt="Image"
            @click="openDialog(item)"
            style="
              border-radius: 3px;
              width: 100%;
              height: 350px;
              object-fit: cover;
            "
          />
          <h3 class="title_style" v-if="items[index].title">
            {{ items[index].title }}
          </h3>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" scrollable max-width="450px">
      <v-card>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <v-card-title><b>ຜູ້ໂຊກດີຖືກລາງວັນ</b></v-card-title>
          <v-btn color="red darken-1" text @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text>
          <v-img
            class="mt-3"
            :src="selectedCard.image"
            contain
            width="100%"
          ></v-img>
          <h2 class="my-3">{{ selectedCard.title }}</h2>
          <div>
            <v-icon>mdi-clock-outline</v-icon>
            {{ formatDate(selectedCard.create_at) }}
          </div>
          <div class="mt-5" v-html="selectedCard.description"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div style="display: flex; justify-content: center">
      <router-link to="/luckyperson">
        <v-btn class="mb-5" color="#9E1C20">
          <span style="color: white"
            >ເບິ່ງທັງໝົດ
            <v-icon>mdi-arrow-right</v-icon>
          </span>
        </v-btn>
      </router-link>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      dialog: false,
      selectedCard: {},
    };
  },
  computed: {
    ...mapGetters("luckyperson", ["items", "textt"]),
    displayedImages() {
      return this.items.slice(0, 3);
    },
  },
  methods: {
    ...mapActions("luckyperson", ["LuckyP"]),
    openDialog(item) {
      this.selectedCard = item;
      this.dialog = true;
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  async mounted() {
    await this.LuckyP();
  },
};
</script>

<style scoped>
.title_style {
  margin-top: 10px;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
